module.exports = __webpack_public_path__ + "img/caas1-m@2.a31f55c3.jpg";